import { styled } from '@mui/material/styles';

export const AccordionIconWrapper = styled('div')`
  transition: all 200ms ease-in-out;
  transform: ${(props) => (props.expanded ? 'rotate(90deg)' : 'rotate(0deg)')};
`;
